import React from 'react';
import styles from './UserWalletTransactionHistoryItem.module.scss';
import FormattedMomentDate, {
	DateFormat,
} from '../../../Base/Components/FormattedMomentDate/FormattedMomentDate';
import usePaymentMethod from '../../../Base/Hooks/usePaymentMethod';
import { Invoice, Order, OrderStatus } from '../../../../graphql/graphql';
import LinkButton from '../../../BaseModule/Components/Button/LinkButton/LinkButton';
import Text from '../../../BaseModule/Components/Text';
import { joinClasses } from '../../../../Utils/className.util';

interface Props {
	item: Order;
}

type InvoiceWithNumber = Invoice & { number: string };

const UserWalletTransactionHistoryItem: React.FC<Props> = ({ item }) => {
	const { issueDate, name, price, paymentMethod, invoices, status } = item;
	const { getPaymentMethodLabel } = usePaymentMethod();
	const isCanceled = status === OrderStatus.Canceled;

	const invoicesWithNumber =
		invoices?.filter(
			(invoice): invoice is InvoiceWithNumber => !!invoice.number,
		) ?? [];

	return (
		<div
			className={joinClasses([
				styles.wrapper,
				isCanceled ? styles.canceled : '',
			])}
		>
			<div>
				<div>
					<FormattedMomentDate date={issueDate} format={DateFormat.DATE_TIME} />
				</div>
				<div className={styles.title}>{name}</div>
				{isCanceled && (
					<Text tx='component.userWalletTransactionHistoryItem.canceled' />
				)}
				{invoicesWithNumber.map(invoice => (
					<div className={styles.invoice} key={invoice.id}>
						<Text className={styles.name} tx='base.invoice' firstUpper />
						<LinkButton
							text={invoice.number}
							theme='purple'
							href={invoice.url}
						/>
					</div>
				))}
			</div>
			<div className={styles.rightPart}>
				{price && <div className={styles.amount}>{price.formattedPrice}</div>}
				{paymentMethod && getPaymentMethodLabel(paymentMethod)}
			</div>
		</div>
	);
};

export default UserWalletTransactionHistoryItem;
